export enum ScannerPrimarySearchList {
    SCANNER_NA = "NA",
    SCANNER_WIZARD = "scanner_wizard",
    SCANNER_CHARTING = "scanner_charting",
    SCANNER_TIWIZARD = "scanner_tiwizard",
    SCANNER_ENTRYSIGNALS = "scanner_entrysignals",
}


// export function getquotePanelsTabsList(): string[][] {
//     let res: string[][]=[];
//     for (const n in ScannerPrimarySearchList) {
//         if (ScannerPrimarySearchList.hasOwnProperty(n)) {
//             res.push([n,ScannerPrimarySearchList[n]]);
//         }
//     }
//     return res;
// }

export function ScannerPrimarySearchListItems (): object {
    let tabsParams: { id: string, label: string, image?: string }[] = [
        { "id": ScannerPrimarySearchList.SCANNER_NA, "label": " ", image: "/images/landing-page/toll-select.png" },
        { "id": ScannerPrimarySearchList.SCANNER_WIZARD, "label": "Wizard", image: "/images/landing-page/Wizard.png?v=5" },
        { "id": ScannerPrimarySearchList.SCANNER_CHARTING, "label": "Charting", image: "/images/landing-page/Charting.png?v=5" },
        { "id": ScannerPrimarySearchList.SCANNER_TIWIZARD, "label": "Tl Wizard", image: "/images/landing-page/TI-Wizard.png?v=5" },
        { "id": ScannerPrimarySearchList.SCANNER_ENTRYSIGNALS, "label": "Entry signals", image: "/images/landing-page/Entry-Signals.png?v=5" },

    ];
    return tabsParams;
}


export enum ScannerSide {
    SCANNER_SIDE_BUY = "scanner_side_buy",
    SCANNER_SIDE_SELL = "scanner_side_sell"
}



export function getSideName(side: string): string {
    var p = (ScannerSideListItems() as { id: string, label: string }[]).filter(x => x.id == side);
    return p.length > 0 ? p[0].label : "";
}




export function ScannerSideListItems (): object {
    let tabsParams: { id: string, label: string }[] = [
        { "id": ScannerSide.SCANNER_SIDE_BUY, "label": "Buy/Long" },
        { "id": ScannerSide.SCANNER_SIDE_SELL, "label": "Sell/Short" },

    ];
    return tabsParams;
}


export enum ScannerChartingStudy {
    SCANNER_UNKNOWN = "scanner_unknown",
    SCANNER_RSI = "scanner_charting_rsi",
    SCANNER_BOLLINGERBANDS = "scanner_charting_bb",
    SCANNER_EMA = "scanner_charting_ema",
    SCANNER_MACD = "scanner_charting_macd",
    //   SCANNER_SIDE_SELL = "scanner_side_sell"
}

export function ScannerChartingStudyItems (): object {
    let tabsParams: { id: string, label: string }[] = [
        { "id": ScannerChartingStudy.SCANNER_RSI, "label": "Relative Strength Index (RSI)" },
        { "id": ScannerChartingStudy.SCANNER_BOLLINGERBANDS, "label": "Bollinger Bands" },
        { "id": ScannerChartingStudy.SCANNER_EMA, "label": "(EMA) Expotential MovingAverage" },
        { "id": ScannerChartingStudy.SCANNER_MACD, "label": "MACD" },
    ];
    return tabsParams;
}

export function getStudyName(side: string): string {
    var p = (ScannerChartingStudyItems() as { id: string, label: string }[]).filter(x => x.id == side);
    return p.length > 0 ? p[0].label : "";
}






export enum ScannerInstrumentList {
    SCANNER_CHWIZARD = "chwizard",
    SCANNER_TIWIZARD = "tiwizard",
    SCANNER_ENTRYSIGNALS = "entrysignals",
    SCANNER_CHARTING_RSI = "charting_rsi",
    SCANNER_CHARTING_BOLLINGERBANDS = "charting_bb",
    SCANNER_CHARTING_EMA = "charting_ema",
    SCANNER_CHARTING_MACD = "charting_macd"
}

export enum scanDirection {
    SCAN_ENTRY_UP = 1,
    SCAN_ENTRY_DOWN = -1
}